module.exports = __webpack_public_path__ + "img/symphony_590_mousey.882d49a0.jpg";